import React, { useState } from "react";
import { Drawer, Menu, Divider, message } from "antd";
import { useDrawer } from "./menuContext";
import { useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import JumpS from "../../common/JumpS";
import InstantReportModal from "../../landingPage/InstantReportModal";
import moment from "moment";
import axiosInstance from "../../../service/AxiosInstance";
import "./drawermenu.css";
import BlackLogo from "../../../static/images/Jump_Black.png"
import { APP_PREFIX_PATH } from "../../../Config/AppConfig";
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const DrawerMenu = () => {
  const { state, dispatch } = useDrawer();
  const [openKeys, setOpenKeys] = useState(["sub1"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [dealerData, setDealerData] = useState();
  const [warning, setWarning] = useState(false);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedMenuKey, setSelectedMenuKey] = useState(null);
  const [newValuationName, setNewValuationName] = useState(
    "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm")
  );
  const handleDrawerClose = () => {
    setSelectedMenuKey(null);
    dispatch({ type: "CLOSE_DRAWER" });
  };
  const navigate = useNavigate();
  const showModal = () => {
    const saveForm = {
      status: false,
      step: 0,
    };
    dispatch({ type: "UPDATE_PAYLOAD_DB", value: saveForm });
    dispatch({ type: "SET_STEP", value: 0 });

    // Set flag to prevent tracking only when navigating from landing page drawer menu
    const currentPath = window.location.pathname;
    if (currentPath.includes('/home') || currentPath === '/JumpFive/home' || currentPath === '/') {
      sessionStorage.setItem('skipDrawerMenuTracking', 'true');
    }

    setIsModalOpen(true);
    setSelectedDealerId(null);
    setNewValuationName(
      "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm")
    );
    const dealerInfo = JSON.parse(sessionStorage.getItem("dealer_name"));
    if (!dealerData && !dealerInfo) {
      FetchedDealerInfo();
    } else if (dealerInfo) {
      setDealerData(dealerInfo.dealerships);
      setLoading(false);
    }
    // !dealerData && FetchedDealerInfo();
    handleDrawerClose();
  };

  const warningModal = () => {
    messageApi.open({
      type: "warning",
      content: "This feature is under development",
    });
  };

  const openAIAnalytics = () => {
    const hasReportAccess = sessionStorage.getItem("has_report_access");
    if (hasReportAccess === "true") {
      navigate(`/${APP_PREFIX_PATH}/ai-analytics`);
      handleDrawerClose();
    } else {
      warningModal();
      handleDrawerClose();
    }
  };

  const items = [
    getItem(
      <Link to="/JumpFive/home" onClick={showModal}>
        Instant Report
      </Link>,
      "sub1"

      // <MoneyCollectOutlined />
    ),
    getItem(
      <Link to="/JumpFive/valuations" onClick={handleDrawerClose}>
        Valuation Directory
      </Link>,
      "sub2"
    ),
    getItem(
      <Link
        to="/JumpFive/Portfolio/PortfolioDirectory"
        onClick={handleDrawerClose}
      >
        Portfolio Directory
      </Link>,
      "sub3"
    ),
    getItem(
      <Link
        to="/JumpFive/Portfolio/PortfolioBuilder"
        onClick={handleDrawerClose}
      >
        Portfolio Builder
      </Link>,
      "sub4"
    ),
    getItem("Groups", "sub5"),
    getItem("AI & Analytics", "sub6"),
    { type: "divider" },
    JSON.parse(sessionStorage.getItem("is_superuser")) === true &&
      getItem("Administration", "sub7", <SettingOutlined />, [
        getItem(
          <Link
            to="/JumpFive/adminPanel/dealerships"
            onClick={handleDrawerClose}
          >
            Dealerships
          </Link>,
          "1"
        ),
        getItem(
          <Link to="/JumpFive/adminPanel/kpiadmin" onClick={handleDrawerClose}>
            KPI
          </Link>,
          "2"
        ),
        getItem(
          <Link
            to="/JumpFive/adminPanel/basemultiple"
            onClick={handleDrawerClose}
          >
            Base Multiples
          </Link>,
          "3"
        ),
        // getItem(<Link to="/JumpFive/adminPanel/factors">Factors</Link>,'3'),
        getItem(
          <Link
            to="/JumpFive/adminPanel/state-brand-multiple"
            onClick={handleDrawerClose}
          >
            State Brand Multiple
          </Link>,
          "4"
        ),
        getItem(
          <Link
            to="/JumpFive/adminPanel/dealershipSales"
            onClick={handleDrawerClose}
          >
            Dealership Sales
          </Link>,
          "5"
        ),
        getItem(
          <Link
            to="/JumpFive/adminPanel/assignDealers"
            onClick={handleDrawerClose}
          >
            Assign Dealers to User
          </Link>,
          "6"
        ),
        getItem(
          <Link
            to="/JumpFive/adminPanel/lastLogins"
            onClick={handleDrawerClose}
          >
            Last Logins
          </Link>,
          "7"
        ),
        getItem(
          <Link
            to="/JumpFive/adminPanel/feedbacks"
            onClick={handleDrawerClose}
          >
            Feedback
          </Link>,
          "8"
        ),
        // getItem(
        //   <Link to="/JumpFive/adminPanel/tunings" onClick={handleDrawerClose}>
        //     Tunings
        //   </Link>,
        //   "5"
        // ),

        // getItem('Groups', '4'),
        // getItem('Brands', '5'),
        // getItem('Profitability Categories', '6'),
        // getItem('Settings','7')
      ]),
    getItem(<JumpS />),
  ];
  const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
    if (latestOpenKey == "2") {
      handleDrawerClose();
    }
  };

  const handleOk = (valuationId) => {
    // Handle success and navigate
    setIsModalOpen(false);
    navigate(`/JumpFive/Valuations/ValuationEdit/${valuationId}`);
    const saveForm = {
      status: false,
      step: 1,
      prevStep: 0,
    };
    // To navigate to Radius page, from there it will navigate to Report page
    dispatch({ type: "UPDATE_PAYLOAD_DB", value: saveForm });
    dispatch({ type: "SET_STEP", value: 1 });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedDealerId(null);
    setNewValuationName("");
    setWarning(false);
  };
  const FetchedDealerInfo = async () => {
    try {
      const { data: response } = await axiosInstance.get(
        `/get_dealership_suggestions?version=V2`,
        {
          params: {
            username: sessionStorage.getItem("user_name"),
          },
        }
      );
      setDealerData(response.dealerships);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const selectedDealerSelectionID = (id) => {
    setSelectedDealerId(+id);
  };

  const handleMenuClick = (e) => {
    if (e.key === "sub5") {
      warningModal();
      handleDrawerClose();
    } else if (e.key === "sub6") {
      openAIAnalytics();
    }
  };

  const handleLogoClick = () => {
    navigate("/JumpFive/home");
    handleDrawerClose();
  };

  return (
    <Drawer
      // title={<img src="/img/JumpV_Th.JumpV_Logo.png" height="32px" />}
      title={
        <span
          style={{ fontWeight: "900", fontSize: "20px", marginLeft: "25px" }}
        >
          <img 
            className="white_logo" 
            src={BlackLogo}
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          />
        </span>
      }
      open={state.drawerVisible}
      onClose={handleDrawerClose}
      closeIcon={false}
      placement="left"
      width={300}
      className="drawer-menu"
    >
      {contextHolder}
      <Menu
        mode="inline"
        openKeys={openKeys}
        selectedKeys={[selectedMenuKey]}
        onOpenChange={onOpenChange}
        onClick={handleMenuClick}
        style={{
          width: 256,
        }}
        items={items}
      />

      <InstantReportModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        dealerData={dealerData}
        selectedDealerId={selectedDealerId}
        newValuationName={newValuationName}
        setNewValuationName={setNewValuationName}
        warning={warning}
        setWarning={setWarning}
        loading={loading}
        selectedDealerSelectionID={selectedDealerSelectionID}
        setSelectedDealerId={setSelectedDealerId}
        setIsModalOpen={setIsModalOpen}
      />
    </Drawer>
  );
};

export default DrawerMenu;
